<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="400px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Share Referral Link</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form
          :fields="referral"
          method="post"
          :action="url"
          @submitted="$emit('shared', $event)"
        >
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-select
                  name="via"
                  :items="modes"
                  @changed="(value) => (mode = value)"
                  label="Share Via"
                />
              </v-col>
              <v-col cols="12" v-if="mode === 'email'">
                <custom-input name="email" type="email" label="Referee Email" />
              </v-col>
              <v-col cols="4" class="pr-2" v-if="mode === 'sms'">
                <custom-input name="country_code" label="Country Code" />
              </v-col>
              <v-col cols="8" v-if="mode === 'sms'">
                <custom-input name="phone_number" label="Referee Phone Number" />
              </v-col>
              <v-col cols="12">
                <custom-input name="referee_name" label="Referee Name" />
              </v-col>
            </v-row>
          </v-container>
          <custom-button block color="primary">
            <v-icon>mdi-share-all-outline</v-icon>Add Referral</custom-button
          >
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    campaign_id: { required: true, type: [Number, String] },
    referral: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      mode: "",
      modes: [
        { text: "SMS", value: "sms" },
        { text: "Email", value: "email" },
      ],
    };
  },
  computed: {
    url() {
      return `/api/v1/shareCampaignReferralLink/${this.campaign_id}`;
    },
  },
};
</script>
